import {create} from 'zustand'

import type {Edge} from '@atlaskit/pragmatic-drag-and-drop-hitbox/types'
import type {EufePageFragment} from '@sdox/api'

export interface MutatePageMeta {
  needlePageId?: string
  position?: Edge
}

export interface PageDialogStoreState {
  isOpen: boolean
  pageId: undefined | EufePageFragment['id']
  meta?: MutatePageMeta
  open: (pageId?: EufePageFragment['id'], meta?: MutatePageMeta) => void
  close: () => void
}

export const usePageDialogStore = create<PageDialogStoreState>((set) => ({
  pageId: undefined,
  isOpen: false,
  meta: undefined,
  open: (pageId?, meta?) => set({
    isOpen: true,
    pageId,
    meta,
  }),
  close: () => set({isOpen: false, pageId: undefined, meta: undefined}),
}))
